export default "__VITE_ASSET__8961463e__"